import React, { createContext, useContext, useMemo } from 'react';
import { AxiosInstance } from 'axios';
import { createZepetofulClient } from './client';
const ZepetofulClientContext = createContext<ZepetofulContextType>({
  client: createZepetofulClient(),
  locale: 'en'
});
export const ZepetofulProvider = (props: ZepetofulProviderProps) => {
  const {
    locale,
    children
  } = props;
  const client = useMemo(() => createZepetofulClient(locale), [locale]);
  return <ZepetofulClientContext.Provider value={{
    client,
    locale
  }} data-sentry-element="unknown" data-sentry-component="ZepetofulProvider" data-sentry-source-file="ZepetofulProvider.tsx">
      {children}
    </ZepetofulClientContext.Provider>;
};
export const useZepetofulContext = () => {
  return useContext(ZepetofulClientContext);
};
export const useZepetofulClient = () => {
  return useZepetofulContext().client;
};
export interface ZepetofulConfig {
  locale: string;
}
export interface ZepetofulProviderProps extends ZepetofulConfig {
  children: React.ReactNode;
}
export interface ZepetofulContextType extends Pick<ZepetofulConfig, 'locale'> {
  client: AxiosInstance;
}